import { GaugeWidgetFormStrings } from "constants/constantStrings";

import RightGauge from "assets/Gauge/GaugeHigh/gauge_high";
import LeftGauge from "assets/Gauge/GaugeLow/gauge_low";
import CenterGauge from "assets/Gauge/GaugeMiddle/gauge_middle";

const TYPES = [
  { id: "leftGauge", type: "LeftGauge", icon: LeftGauge, text: GaugeWidgetFormStrings.lowerValues },
  { id: "middleGauge", type: "MiddleGauge", icon: CenterGauge, text: GaugeWidgetFormStrings.middleValue },
  { id: "rightGauge", type: "RightGauge", icon: RightGauge, text: GaugeWidgetFormStrings.higherValue }
];

const DEFAULT_THRESHOLD = [
  { label: GaugeWidgetFormStrings.low_low, value: "", id: "Detail1", isInvalid: false, error: GaugeWidgetFormStrings.lowestValue },
  { label: GaugeWidgetFormStrings.low, value: "", id: "Detail2", isInvalid: false, error: GaugeWidgetFormStrings.secondLowest },
  { label: GaugeWidgetFormStrings.high, value: "", id: "Detail3", isInvalid: false, error: GaugeWidgetFormStrings.secondHighest },
  { label: GaugeWidgetFormStrings.high_high, value: "", id: "Detail4", isInvalid: false, error: GaugeWidgetFormStrings.highestValue }
];

export default {
  DEFAULT_THRESHOLD,
  TYPES
};
